import $ from "jquery";

class Comments {
    constructor() {
        $('.comment-form').on('submit', function(event) {
            event.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: $(this).serialize() + '&action=ajaxcomments',
                    beforeSend: function() {
                        $('.button-text').text('PUBLICANDO');
                        $('.button-text').addClass('loading');
                        $('.message-error').removeClass('show');
                        $('.message-success').removeClass('show');
                    },
                    success: function(data) {
                        console.log(data);
                        $('.button-text').text('PUBLICAR');
                        $('.button-text').removeClass('loading');
                        $('.message-success').addClass('show');
                    },
                    error: function (request, status, error) {
                        if( status == 500 ){
                            $('.message-error').addClass('show');
                        } else if( status == 'timeout' ){
                            $('.message-error').addClass('show');
                        } else {
                            $('.message-error').html(error);
                        }
                    },
                });
            
        });
    }
}

export default Comments;